import React from 'react';

// --- Data for the project cards ---
const cardDataTop = [
  { 
    title: "Client System Hacking", 
    image: "https://skillsuprise.com/data/cyberPDF/projects/Client System Hacking.png" 
  },
  { 
    title: "SOC Analysis of Client Website", 
    image: "https://skillsuprise.com/data/cyberPDF/projects/SOC Analysis of Client Website.png" 
  },
  { 
    title: "Virus & Malware Development using AI", 
    image: "https://skillsuprise.com/data/cyberPDF/projects/Virus & Malware Development using AI.png" 
  },
  { 
    title: "Performing Penetration Testing on Client Website", 
    image: "https://skillsuprise.com/data/cyberPDF/projects/Performing Penetration Testing on Client Website.png" 
  },
  { 
    title: "Hacking Tool Development", 
    image: "https://skillsuprise.com/data/cyberPDF/projects/Hacking Tool Development.png" 
  },
  { 
    title: "Web Server Hacking of Client Network", 
    image: "https://skillsuprise.com/data/cyberPDF/projects/Web Server Hacking of Client Network.png" 
  },
];

// --- Data for the last card ---
const lastCard = { 
  title: "Hardware Hacking Tools Development", 
  image: "https://skillsuprise.com/data/cyberPDF/projects/Hardware Hacking Tools Development.png" 
};

// --- Internal CSS for all styling ---
const internalCSS = `
  /* --- Main Page Container --- */
  .projects-page-container {
    background-color: #fff; /* White background for the whole page */
  }

  /* --- 1. Top Banner Section --- */
  .projects-top-banner {
    position: relative;
    width: 100%;
    height: 350px; /* Fixed height for the banner */
    overflow: hidden;
    display: flex;
    align-items: center;
    background-color: #1a1a1a; /* Fallback background */
  }

  .projects-banner-bg-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
    opacity: 0.5; /* Dim the image */
  }

  .projects-banner-content {
    position: relative;
    z-index: 1;
    color: #fff;
    text-align: left;
    max-width: 1140px;
    margin: 0 auto;
    padding: 2rem;
  }

  .projects-banner-title {
    font-family: 'Poppins', 'Open Sans', sans-serif;
    font-size: 2.8rem;
    font-weight: 700;
    line-height: 1.2;
    background-color: #000000ff; /* Yellow highlight */
    color: #ffc107; /* Dark text on highlight */
    padding: 0.1rem 0.75rem;
    display: inline;
  }

  .projects-banner-subtitle {
    font-family: 'Poppins', 'Open Sans', sans-serif;
    font-size: 1.25rem;
    color: white;
    font-weight: 400;
    line-height: 1.6;
    margin-top: 1rem;
    max-width: 500px;
  }
  
  /* --- 2. Cards Grid Section --- */
  .projects-grid-section {
    padding: 4rem 1rem;
    background-color: #f8f9fa; /* Light grey bg for card area */
  }

  .project-card {
    background-color: #fff;
    border-radius: 12px;
    overflow: hidden;
    height: 100%;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.07);
    border: none;
    transition: transform 0.2s ease;
  }

  .project-card:hover {
    transform: translateY(-5px);
  }

  .project-card-img {
    width: 100%;
    height: 130px; /* Fixed height for all images */
    object-fit: cover;
  }

  .project-card-body {
    
    text-align: center;
  }
  
  .project-card-title {
    font-family: 'Poppins', 'Open Sans', sans-serif;
    font-size: 1.1rem;
    font-weight: 600;
    color: #333;
    line-height: 1.4;
  }
  
  /* --- 3. Interstitial Text Section (for the last row) --- */
  .interstitial-text-section {
    text-align: center;
    /* Remove padding to let flexbox center it */
    padding: 0; 
  }
  
  .interstitial-title-main {
    font-family: 'Poppins', 'Open Sans', sans-serif;
    font-size: 3rem;
    font-weight: 700;
    color: #d90429; /* Bright Red */
    line-height: 1.2;
    margin-bottom: 1rem;
  }
  
  .interstitial-subtitle {
    font-family: 'Poppins', 'Open Sans', sans-serif;
    font-size: 1.25rem;
    font-weight: 500;
    color: #333;
    line-height: 1.6;
    max-width: 700px;
    margin: 0 auto;
  }

  /* --- ########## RESPONSIVE OVERRIDES ########## --- */
  /* This section forces the 3-column layout onto mobile */
  
  @media (max-width: 767.98px) {
    /* Shrink Banner */
    .projects-top-banner {
      height: 130px;
    }
    .projects-banner-title {
      font-size: 1rem;
    }
    .projects-banner-subtitle {
      font-size: 0.7rem;
      margin-top: 0.75rem;
    }
    
    /* Shrink Card Grid */
    .projects-grid-section {
      padding: 1.5rem 0.5rem;
    }
    .project-card-img {
      height: 60px; /* Smaller image */
    }
    .project-card-body {
    
    }
    .project-card-title {
      font-size: 0.6rem !important;
      line-height: 1.2;
    }
    
    /* Shrink Interstitial Text */
    .interstitial-title-main {
      font-size: 1.2rem;
    }
    .interstitial-subtitle {
      font-size: 0.7rem;
      margin-left: 13px;
    }

    /* --- NEW: Force 3-column layout for the last row on mobile --- */
    .last-row-col-card {
      /* This will be 1/3 width */
      flex: 0 0 auto;
      width: 33.33333%;
    }
    .last-row-col-text {
      /* This will be 2/3 width */
      flex: 0 0 auto;
      width: 66.66667%;
    }
  }
`;

const RealTimeProjects = () => {
  return (
    <>
      <style>{internalCSS}</style>
      
      <div className="projects-page-container">
        
        {/* --- 1. Top Banner Section --- */}
        <div className="projects-top-banner">
          <img 
            src="https://skillsuprise.com/data/cyberPDF/chapters/chapter2.png" 
            alt="Projects Background" 
            className="projects-banner-bg-img" 
          />
          <div className="projects-banner-content">
            <h3 className="projects-banner-title">
              10+ Real-time Hacking Projects
            </h3>
            <p className="projects-banner-subtitle">
              Say No to Virtual Labs and demo projects. Work directly with 
              out client projects for hands-on experience
            </p>
          </div>
        </div>
        
        {/* --- 2. Cards Grid Section --- */}
        <div className="projects-grid-section">
          <div className="container">
            
            {/* --- First Row (6 Cards) --- */}
            <div className="row row-cols-3 g-3 g-md-4 mb-3 mb-md-4">
              {cardDataTop.map((card, index) => (
                <div className="col" key={index}>
                  <div className="card project-card">
                    <img src={card.image} className="project-card-img" alt={card.title} />
                    <div className="card-body project-card-body">
                      <h5 className="card-title project-card-title">{card.title}</h5>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            
            {/* --- NEW: Last Row (Card + Text) --- */}
            <div className="row g-3 g-md-4 d-flex align-items-center">
              
              {/* --- Last Card (Left Column) --- */}
              <div className="col-md-4 last-row-col-card">
                <div className="card project-card">
                  <img src={lastCard.image} className="project-card-img" alt={lastCard.title} />
                  <div className="card-body project-card-body">
                    <h4 className="card-title project-card-title">{lastCard.title}</h4>
                  </div>
                </div>
              </div>
              
              {/* --- Text (Right Column) --- */}
              <div className="col-md-8 last-row-col-text">
                <div className="interstitial-text-section">
                  <h3 className="interstitial-title-main">
                    MASTER HACKING 100% PRACTICALLY
                  </h3>
                  <p className="interstitial-subtitle text-start">
                    Work with many such real-time practical hacking projects to gain
                    hands-on experience on hacking
                  </p>
                </div>
              </div>
              
            </div>
            
          </div>
        </div>
        
      </div>
    </>
  );
};

export default RealTimeProjects;